(() => {
  const root = document.querySelector('[data-relief-product]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const q = selector => root.querySelector(selector);
  const qa = selector => [...root.querySelectorAll(selector)];
  const order = globalThis.HeirloomReliefOrder;
  const form = q('[data-relief-form]');
  const submit = q('[data-relief-submit]');
  const paypal = q('[data-snowman-paypal]');
  const submitLabel = q('[data-relief-submit-label]');
  const savingDialog = q('[data-relief-saving-dialog]');
  const savingTitle = q('[data-relief-saving-title]');
  const savingMessage = q('[data-relief-saving-message]');
  const status = q('[data-relief-status]');
  let silentCart = false;
  const setStatus = (text, error = false) => { status.textContent = silentCart && !error ? '' : text; status.hidden = silentCart && !error; status.dataset.error = String(error); };
  form.addEventListener('submit', event => event.preventDefault());
  const product = JSON.parse(q('[data-relief-catalog]').textContent);
  const requiredPhotoCount = order?.photoCount?.(product) || 1;
  const supportsPhoto = requiredPhotoCount === 3 || product.personalizationMode !== 'text-only';
  const preparation = supportsPhoto ? globalThis.HeirloomMemoryPhotos : null;
  const upload = globalThis.HeirloomCartUpload;
  const server = globalThis.HeirloomPersonalizationServer;
  let eagerUploads = false, checkoutAssetRefs = false, checkoutAssetRefsPromise = null;
  if (!order || (supportsPhoto && !globalThis.JSZip)) { setStatus('Personalization could not be loaded. Please refresh to try again.', true); return; }
  if (!upload || (supportsPhoto && !preparation)) { setStatus('Photo preparation could not be loaded. Please refresh to try again.', true); return; }
  const optionInputs = qa('[data-relief-option]');
  const photos = qa('[data-relief-file]').map((input, index) => ({
    input, index, box: input.closest('.relief-upload-box'), file: null, asset: null, objectUrl: null, revision: 0, loading: false, uploading: false, uploadError: false,
  }));
  if (supportsPhoto && photos.length !== requiredPhotoCount) { setStatus('Photo uploads could not be loaded. Please refresh to try again.', true); return; }
  const message = q('[data-relief-message]');
  const cartUrl = new URL(root.dataset.cartUrl, location.origin);
  const checkoutUrl = new URL(root.dataset.checkoutUrl || cartUrl.href, location.origin);
  if (checkoutUrl.origin !== location.origin) { setStatus('Checkout could not be loaded. Please refresh.', true); return; }
  const directCheckout = Boolean(root.dataset.checkoutUrl);
  const addUrl = new URL(form.action);
  addUrl.pathname += '.js';
  const pendingKey = `3dh-relief-pending:${product.handle}`;
  let busy = false, leaving = false, pending = null, previewRequestMode = null, activeLoginGate = null, serverPending = null, busyAction = null, preparedAttempt = null, archiveController = null, archiveTimer = 0;
  const serverPendingKey = `3dh-relief-server-pending:${product.handle}`;
  try { serverPending = JSON.parse(sessionStorage.getItem(serverPendingKey) || 'null'); } catch { serverPending = null; }
  const saveServerPending = () => { try { if (serverPending) sessionStorage.setItem(serverPendingKey, JSON.stringify(serverPending)); else sessionStorage.removeItem(serverPendingKey); } catch { /* recovery aid only */ } };
  const purchaseMode = () => order.purchaseMode(product, variant());
  const requiresPhoto = () => purchaseMode() === 'photo';
  const loading = () => requiresPhoto() && photos.some(photo => photo.loading || photo.uploading);
  // Multi-photo designs remain one backend archive; Shopify only receives the signed reference.
  const eagerForPhoto = () => eagerUploads && requiredPhotoCount === 1;
  const photosReady = () => !requiresPhoto() || photos.length === requiredPhotoCount && photos.every(photo => !!photo.file && (!eagerForPhoto() || photo.asset));
  const readyStatus = () => {
    if (purchaseMode() === 'featured') return 'No drawing needed. Add an optional message or continue to add to cart.';
    if (!requiresPhoto()) return 'Add a message or continue without text.';
    if (loading()) return photos.some(photo => photo.uploading) ? 'Uploading your photo…' : 'Preparing the photos for your design…';
    if (eagerUploads && photos.some(photo => photo.uploadError)) return 'One photo could not be saved. Choose it again to retry.';
    if (requiredPhotoCount === 3) {
      const count = photos.filter(photo => photo.file).length;
      return count === 3 ? 'All 3 photos prepared locally. Continue to save your customization.' : `${count} of 3 photos prepared locally. Choose all 3 to save them.`;
    }
    if (product.designChoice) return photosReady() ? 'Drawing selected. Ready to add to cart.' : "Upload your child's drawing to continue.";
    return photosReady() ? 'Photo selected. Ready to add to cart.' : 'Upload your photo to continue.';
  };
  savingDialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch { /* A new page can still upload without session storage. */ }
  if (pending && (!pending.id || !pending.variantId || (!pending.server && !pending.fields))) pending = null;
  if (pending?.server) {
    const catalogVariant = product.variants.find(item => String(item.id) === String(pending.variantId));
    // Older pending receipts stored the internal binding SKU in the catalog SKU field.
    if (catalogVariant) pending.sku = catalogVariant.sku || '';
  }
  const options = () => optionInputs.length ? optionInputs.map(input => input.value) : product.variants[0].options;
  const variant = () => order.selectVariant(product, options());
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
  const galleryImage = q('[data-relief-main-image]');
  const galleryButtons = qa('[data-relief-image]');
  let galleryIndex = Math.max(0, galleryButtons.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
  const showImage = (index, source) => {
    if (!galleryImage || (!source && !galleryButtons.length)) return;
    if (!source) galleryIndex = (index + galleryButtons.length) % galleryButtons.length;
    const button = source ? null : galleryButtons[galleryIndex];
    const src = source || button.dataset.reliefImage;
    const url = new URL(src, location.href);
    const shopifyImage = /^https?:$/.test(url.protocol) && !url.searchParams.has('height') && (
      (url.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(url.pathname)) ||
      ((url.origin === location.origin || url.hostname === '3dheirloom.com') && /^\/cdn\/shop\/(?:files|products|t\/\d+\/assets)\//.test(url.pathname))
    );
    galleryImage.sizes = '(max-width: 800px) calc(100vw - 36px), (max-width: 1280px) calc(52.5vw - 42px), 630px';
    if (shopifyImage) galleryImage.srcset = [400, 600, 800, 1000, 1400].map(width => {
      url.searchParams.set('width', String(width));
      return `${url.href} ${width}w`;
    }).join(', ');
    else galleryImage.removeAttribute('srcset');
    galleryImage.src = src;
    galleryButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    if (!button) return;
    const rail = button.parentElement;
    rail.scrollTo({ left: button.offsetLeft - rail.offsetLeft - (rail.clientWidth - button.clientWidth) / 2, behavior: 'auto' });
  };
  galleryButtons.forEach((button, i) => button.addEventListener('click', () => showImage(i)));
  let touchStart = null;
  q('[data-relief-gallery-stage]').addEventListener('touchstart', event => { touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null; }, { passive: true });
  q('[data-relief-gallery-stage]').addEventListener('touchend', event => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart.x, dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(galleryIndex + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
  const render = () => {
    const selected = variant();
    q('[data-relief-variant]').value = selected?.available ? selected.id : '';
    q('[data-relief-price]').textContent = q('[data-relief-total]').textContent = selected ? money(selected.price) : '—';
    const sale = q('[data-series-sale]');
    if (sale) {
      sale.replaceChildren();
      if (Number(selected?.compare_at_price) > Number(selected?.price)) {
        const original = document.createElement('span'), badge = document.createElement('span');
        original.className = 'snowman-compare-price'; original.textContent = money(selected.compare_at_price);
        badge.className = 'snowman-discount'; badge.textContent = Math.round((selected.compare_at_price - selected.price) / selected.compare_at_price * 100) + '% OFF';
        sale.append(original, badge);
      }
    }
    q('[data-relief-availability]').textContent = !selected ? 'This combination is unavailable. Choose another option.' : !selected.available ? 'Sold out — choose another option.' : '';
    if (product.designChoice) {
      const featured = purchaseMode() === 'featured';
      q('[data-relief-photo-section]').hidden = featured;
      q('[data-relief-message-heading]').textContent = 'Personal message · Optional';
      if (root.dataset.hasProductSubtitle !== 'true') q('[data-relief-intro]').textContent = featured
        ? 'A playful gift for someone you love.'
        : 'Their drawing, made into a gift just for them.';
    }
    const ready = photosReady();
    submit.disabled = busy || loading() || !!pending || !selected?.available || !ready;
    if (paypal) paypal.disabled = busy || loading() || !!pending || !selected?.available || !ready || !globalThis.HeirloomSnowmanWallet;
    submit.setAttribute('aria-busy', String(busy && busyAction === 'cart'));
    if (paypal) paypal.setAttribute('aria-busy', String(busy && busyAction === 'wallet'));
    const previewLabel = root.dataset.customerLoggedIn === 'true' ? 'REQUEST FREE PREVIEW' : 'LOGIN & REQUEST FREE PREVIEW';
    submitLabel.textContent = busy
      ? (previewRequestMode ? 'SUBMITTING PREVIEW REQUEST…' : activeLoginGate?.wait ? 'SAVING & SIGNING IN…' : 'ADDING TO CART…')
      : selected && !selected.available
        ? 'SOLD OUT'
        : root.dataset.previewRequestEnabled === 'true'
          ? previewLabel
          : 'ADD TO CART';
    submit.classList.toggle('is-ready', !!selected?.available && ready && !loading() && (busy || !pending));
    q('[data-relief-recovery]').hidden = !pending;
    photos.forEach(photo => {
      const suffix = requiredPhotoCount === 3 ? ` ${photo.index + 1}` : '';
      const transferring = photo.uploading || requiredPhotoCount === 3 && preparedAttempt?.uploading;
      const percent = photo.uploading ? photo.percent : preparedAttempt?.percent;
      photo.box.querySelector('.relief-upload').setAttribute('aria-busy', String(!!transferring));
      photo.box.querySelector('[data-relief-upload-label]').textContent = transferring ? `UPLOADING${percent == null ? '…' : ` ${percent}%`}` : photo.uploadError ? 'RETRY UPLOAD' : photo.loading ? 'PREPARING PHOTO…' : `${photo.file ? 'REPLACE' : 'UPLOAD'} ${product.designChoice ? 'DRAWING' : 'PHOTO'}${suffix}`;
    });
  };
  const clearPhoto = photo => {
    photo.revision++;
    if (requiredPhotoCount === 3) { archiveController?.abort(); preparedAttempt = null; }
    photo.controller?.abort();
    photo.file = null;
    photo.asset = null;
    photo.assetRequestId = null;
    photo.preparation = null;
    photo.loading = false;
    photo.uploading = false;
    photo.percent = null;
    photo.uploadError = false;
    photo.input.value = '';
    if (photo.objectUrl) URL.revokeObjectURL(photo.objectUrl);
    photo.objectUrl = null;
    const thumbnail = photo.box.querySelector('[data-relief-thumbnail]');
    thumbnail.removeAttribute('src');
    thumbnail.hidden = true;
    photo.box.querySelector('[data-relief-selected-photo]').hidden = true;
    photo.box.querySelector('[data-relief-filename]').textContent = '';
    photo.box.querySelector('[data-relief-file-size]').textContent = '';
  };
  const uploadPhotoAsset = async photo => {
    if (!eagerForPhoto() || !server?.uploadAsset || !photo.file || photo.asset || photo.uploading) return;
    const revision = photo.revision;
    const selected = variant();
    if (!selected?.available) throw new Error('Choose an available product option before uploading your photo.');
    photo.uploading = true;
    photo.uploadError = false;
    photo.controller = new AbortController();
    photo.percent = null;
    const onProgress = value => {
      if (revision !== photo.revision) return;
      photo.percent = value.phase === 'transferring' ? value.percent : null;
      render();
    };
    render();
    try {
      const asset = await server.uploadAsset({ productId: product.handle, variantId: selected.id, slot: 'photo-1', version: revision, file: photo.file, signal: photo.controller.signal, onProgress });
      if (revision === photo.revision) photo.asset = asset;
    } catch (error) {
      if (revision === photo.revision) {
        photo.asset = null; photo.uploadError = true;
        setStatus(error.message || 'Photo could not be saved. Tap Retry upload to try again.', true);
      }
      throw error;
    } finally {
      if (revision === photo.revision) { photo.uploading = false; render(); if (!photo.uploadError) setStatus(readyStatus()); void recovery?.save(); }
    }
  };
  const selectFile = async (photo, candidate) => {
    // Cancelling the picker keeps the previous valid photo. Invalid replacements clear it.
    if (!candidate || busy || pending) return;
    clearPhoto(photo);
    const revision = photo.revision;
    photo.loading = true;
    render();
    setStatus(readyStatus());
    let url = null;
    try {
      const type = await order.photoType(candidate);
      if (revision !== photo.revision) return;
      const prepared = preparation ? await preparation.prepare(candidate, () => revision === photo.revision) : null;
      if (revision !== photo.revision) return;
      const uploadFile = prepared?.file || candidate;
      url = URL.createObjectURL(uploadFile);
      let decodable = true;
      try { const image = new Image(); image.src = url; await image.decode(); } catch { decodable = false; }
      if (revision !== photo.revision) { URL.revokeObjectURL(url); return; }
      if (!decodable && type.mime !== 'image/heic') throw new Error('This photo could not be opened. Choose another image.');
      photo.objectUrl = url;
      photo.file = uploadFile;
      photo.preparation = prepared;
      const thumbnail = photo.box.querySelector('[data-relief-thumbnail]');
      thumbnail.src = photo.objectUrl;
      thumbnail.hidden = !decodable;
      photo.box.querySelector('[data-relief-selected-photo]').hidden = false;
      photo.box.querySelector('[data-relief-filename]').textContent = candidate.name;
      photo.box.querySelector('[data-relief-file-size]').textContent = prepared?.changed
        ? `${(candidate.size / 1024 / 1024).toFixed(2)} MB → ${(uploadFile.size / 1024 / 1024).toFixed(2)} MB · Prepared for upload`
        : `${(candidate.size / 1024 / 1024).toFixed(2)} MB${decodable ? '' : ' · HEIC original selected; thumbnail unavailable in this browser.'}`;
      try { await recovery?.save(); } catch { /* Local storage is optional; uploading must still work. */ }
      if (revision !== photo.revision) return;
      if (eagerForPhoto() && server?.uploadAsset) await uploadPhotoAsset(photo);
      if (revision !== photo.revision) return;
      photo.loading = false;
      setStatus(readyStatus());
    } catch (error) {
      if (url && photo.objectUrl !== url) URL.revokeObjectURL(url);
      if (revision === photo.revision) setStatus(`${requiredPhotoCount === 3 ? `Photo ${photo.index + 1}: ` : ''}${error.message || 'Choose another photo.'}`, true);
    } finally {
      if (revision === photo.revision) { photo.loading = false; render(); void recovery?.save(); prepareArchiveInBackground(); }
    }
  };
  photos.forEach(photo => {
    photo.box.querySelector('.relief-upload').addEventListener('click', event => {
      if (!photo.uploadError || busy || pending) return;
      event.preventDefault();
      if (requiredPhotoCount === 3) prepareArchiveInBackground();
      else void uploadPhotoAsset(photo).catch(() => {});
    });
    photo.input.addEventListener('change', () => { void selectFile(photo, photo.input.files?.[0]); });
    photo.box.querySelector('[data-relief-remove]').addEventListener('click', () => {
      if (busy || pending) return;
      clearPhoto(photo);
      prepareArchiveInBackground();
      void recovery?.save();
      setStatus(readyStatus());
      render();
    });
  });
  message.addEventListener('input', () => {
    if (busy || pending) return;
    setStatus(readyStatus()); render(); void recovery?.save();
    if (requiredPhotoCount === 3) {
      archiveController?.abort(); preparedAttempt = null;
      clearTimeout(archiveTimer);
      archiveTimer = setTimeout(() => { archiveTimer = 0; prepareArchiveInBackground(); }, 900);
    } else prepareArchiveInBackground();
  });
  optionInputs.forEach(input => input.addEventListener('change', () => {
    const selected = variant();
    if (selected?.featured_image?.src && galleryImage) {
      const matching = galleryButtons.findIndex(button => new URL(button.dataset.reliefImage, location.href).pathname === new URL(selected.featured_image.src, location.href).pathname);
      if (matching >= 0) showImage(matching);
      else showImage(null, selected.featured_image.src);
    }
    if (product.designChoice && selected) {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(selected.id));
      history.replaceState(history.state, '', url.href);
    }
    if (!pending) setStatus(readyStatus());
    render();
    void recovery?.save();
    prepareArchiveInBackground();
  }));
  const captureDraft = () => ({
    version: 1, productHandle: product.handle, options: options(), message: message.value || '', quantity: Number(form.elements.namedItem('quantity')?.value || 1),
    photos: photos.map(photo => ({ file: photo.file, preparation: photo.preparation || null, asset: photo.asset || null, assetRequestId: photo.assetRequestId || null })),
  });
  const exportPreviewRequest = () => {
    const selected = variant();
    if (!selected?.available || !photosReady()) throw new Error('Choose your options and upload your photo first.');
    return {
      version: 1,
      createdAt: new Date().toISOString(),
      expiresAt: new Date(Date.now() + 12 * 60 * 60 * 1000).toISOString(),
      productHandle: product.handle,
      options: options(),
      message: message.value || '',
      quantity: Number(form.elements.namedItem('quantity')?.value || 1),
      photos: captureDraft().photos,
    };
  };
  const restorePreviewRequest = async (payload) => {
    if (!payload || payload.productHandle !== product.handle) return false;
    if (Array.isArray(payload.options)) {
      optionInputs.forEach((input, index) => { if (payload.options[index] !== undefined) input.value = payload.options[index]; });
    }
    if (message && payload.message !== undefined) message.value = payload.message || '';
    const quantityInput = form.elements.namedItem('quantity');
    if (quantityInput && Number.isSafeInteger(payload.quantity) && payload.quantity > 0) quantityInput.value = String(payload.quantity);
    for (const [index, saved] of (payload.photos || []).entries()) {
      const photo = photos[index];
      if (!photo) continue;
      clearPhoto(photo);
      if (!(saved.file instanceof Blob)) continue;
      photo.file = saved.file;
      photo.preparation = saved.preparation || null;
      photo.asset = saved.asset || null;
      photo.assetRequestId = saved.assetRequestId || null;
      photo.objectUrl = URL.createObjectURL(photo.file);
      const thumbnail = photo.box.querySelector('[data-relief-thumbnail]');
      thumbnail.src = photo.objectUrl;
      thumbnail.hidden = false;
      photo.box.querySelector('[data-relief-selected-photo]').hidden = false;
      photo.box.querySelector('[data-relief-filename]').textContent = photo.file.name || 'Saved photo';
      photo.box.querySelector('[data-relief-file-size]').textContent = `${(photo.file.size / 1024 / 1024).toFixed(2)} MB`;
    }
    render();
    setStatus(readyStatus());
    optionInputs.forEach(input => input.dispatchEvent(new Event('change', { bubbles: true })));
    return true;
  };
  const setPreviewRequestMode = (email = '') => {
    archiveController?.abort(); preparedAttempt = null;
    previewRequestMode = { status: 'free_pending', email: String(email || root.dataset.customerEmail || ''), expiresAt: new Date(Date.now() + 12 * 60 * 60 * 1000).toISOString() };
    render();
    prepareArchiveInBackground();
  };
  const clearPreviewRequestMode = () => { previewRequestMode = null; archiveController?.abort(); preparedAttempt = null; render(); prepareArchiveInBackground(); };
  const fetchCart = () => upload.readCart(`${cartUrl.pathname}.js`);
  const clearPending = () => { pending = null; try { sessionStorage.removeItem(pendingKey); } catch { /* in-memory state remains valid */ } };
  const lock = value => {
    busy = value;
    if (!value) { silentCart = false; busyAction = null; }
    form.setAttribute('aria-busy', String(value));
    qa('fieldset').forEach(fieldset => { fieldset.disabled = value || !!pending; });
    q('[data-relief-recheck]').disabled = value;
    render();
    if (value && !silentCart) {
      const preview = Boolean(previewRequestMode);
      savingTitle.textContent = pending ? 'CHECKING YOUR CART' : preview ? 'SAVING YOUR PREVIEW REQUEST' : 'ADDING YOUR PERSONALIZED GIFT TO CART';
      savingMessage.textContent = pending ? 'Checking your cart for this design…' : preview ? 'Uploading your design to the cart…' : 'Saving to cart…';
      if (!savingDialog.open) savingDialog.showModal();
    } else if (savingDialog.open) savingDialog.close();
  };
  const openCartDestination = () => {
    if (!directCheckout && globalThis.HeirloomCartDrawer) {
      leaving = false; root.inert = false; lock(false);
      globalThis.HeirloomCartDrawer.open(submit, { cartChanged: true });
    } else location.assign(checkoutUrl.href);
  };
  const continueAfterCart = () => {
    leaving = true;
    clearPending();
    previewRequestMode = null;
    setStatus('Your personalized gift is in your cart. Opening your cart…');
    openCartDestination();
  };
  const complete = () => { preparedAttempt = null; continueAfterCart(); };
  const verifySavedDraft = (data, expected) => {
    if (!data?.requestId || (expected.draftReceipt && data.requestId !== expected.draftReceipt.requestId) || String(data.variantId) !== String(expected.variantId) || data.customization?.designId !== expected.id || !['draft', 'checkout_locked'].includes(data.status)) {
      throw new Error('The saved design could not be verified. Please try saving it again before adding to cart.');
    }
  };
  const verifyPendingDraft = async (expected, visit) => {
    const receipt = expected?.draftReceipt;
    if (!server || !receipt?.requestId || !receipt?.editToken) throw new Error('The saved design could not be verified. Review your cart before trying again.');
    const data = await visit.wait(server.request(`/v1/drafts/${encodeURIComponent(receipt.requestId)}`, { headers: { 'x-draft-token': receipt.editToken } }));
    verifySavedDraft(data, expected);
  };
  let savedPurchase = null;
  const purchaseInput = () => ({ key: JSON.stringify([variant()?.id, options(), message.value, Number(form.elements.namedItem('quantity')?.value || 1), previewRequestMode]), files: requiresPhoto() ? photos.map(photo => photo.file) : [] });
  const rememberPurchase = expected => { savedPurchase = { ...purchaseInput(), expected }; };
  const prepareCartAttempt = () => {
    clearTimeout(archiveTimer); archiveTimer = 0;
    const files = requiresPhoto() ? photos.map(photo => photo.file) : [];
    const quantity = Number(form.elements.namedItem('quantity')?.value || 1);
    const selectedVariantId = variant()?.id;
    const canReuseTemporaryAssets = eagerUploads && requiredPhotoCount === 1;
    const previewMode = previewRequestMode ? { ...previewRequestMode } : null;
    const key = JSON.stringify([selectedVariantId, options(), message.value, quantity, previewMode, canReuseTemporaryAssets ? photos.map(photo => photo.asset?.assetId || '') : []]);
    const expired = preparedAttempt?.assets?.some(ref => !(Date.parse(ref.expiresAt) > Date.now()));
    if (!preparedAttempt || expired || preparedAttempt.key !== key || files.length !== preparedAttempt.files.length || files.some((file, i) => file !== preparedAttempt.files[i])) {
      archiveController?.abort();
      const refs = canReuseTemporaryAssets && photos.every(photo => photo.asset && !photo.assetRequestId && photo.asset.productId === product.handle && String(photo.asset.variantId) === String(variant().id) && Date.parse(photo.asset.expiresAt) > Date.now()) ? photos.map(photo => photo.asset) : null;
      const useArchive = requiredPhotoCount === 3 && eagerUploads && server?.uploadAsset;
      const controller = useArchive ? new AbortController() : null;
      archiveController = controller;
      const entry = { key, files, promise: null, assets: null };
      preparedAttempt = entry;
      if (useArchive) photos.forEach(photo => { photo.uploadError = false; });
      entry.uploading = !!useArchive;
      entry.percent = null;
      render();
      const current = () => preparedAttempt === entry && !controller?.signal.aborted;
      entry.promise = order.build({ file: files[0] || null, files, preparations: requiresPhoto() ? photos.map(photo => photo.preparation) : [], assetRefs: refs, product, variantId: variant().id, options: options(), message: message.value, quantity, previewRequest: previewMode }).then(async attempt => {
        if (!useArchive) return attempt;
        if (!current()) throw new Error('The photos or details changed. Please try saving again.');
        const send = (file, purpose, slot) => server.uploadAsset({ productId: product.handle, variantId: selectedVariantId, file, purpose, slot, signal: controller.signal,
          onProgress: value => {
            if (!current()) return;
            if (purpose === 'archive') entry.percent = value.phase === 'transferring' ? value.percent : null;
            render();
          },
        });
        const assets = await Promise.all([
          send(attempt.serverDraft.file, 'archive', 'photos-archive'),
          ...(attempt.serverDraft.preview ? [send(attempt.serverDraft.preview, 'preview', 'preview-1')] : []),
        ]);
        if (!current()) throw new Error('The photos or details changed. Please try saving again.');
        entry.assets = assets;
        attempt.serverDraft.assetRefs = assets;
        attempt.serverDraft.file = null; attempt.serverDraft.preview = null;
        entry.uploading = false; entry.percent = null; render(); setStatus(readyStatus());
        return attempt;
      }).catch(error => {
        controller?.abort();
        if (preparedAttempt === entry) {
          preparedAttempt = null;
          if (useArchive) photos.forEach(photo => { photo.uploadError = true; });
          render();
          setStatus(error.message || 'Could not save the photos. Continue to retry with your selected photos.', true);
        }
        throw error;
      });
    }
    return preparedAttempt.promise;
  };
  const prepareArchiveInBackground = () => {
    if (requiredPhotoCount !== 3 || busy || pending) return;
    const complete = photos.length === 3 && photos.every(photo => photo.file && !photo.loading);
    if (!complete || !variant()?.available) {
      archiveController?.abort(); preparedAttempt = null;
     
      return;
    }
    if (!eagerUploads || !server?.uploadAsset) {
      setStatus('All 3 photos prepared locally. They will be saved when you continue.');
      return;
    }
    void prepareCartAttempt().catch(() => {});
  };
  const saveCartDraft = async (attempt, visit) => {
    if (attempt.draftReceipt) {
      await verifyPendingDraft({ ...attempt.expected, draftReceipt: attempt.draftReceipt }, visit);
      return attempt.draftReceipt;
    }
    if (!server || !attempt.serverDraft) throw new Error('Design saving could not be loaded. Please refresh to try again.');
    const saved = await visit.wait(server.draft(attempt.serverDraft));
    if (saved?.requestId && attempt.serverDraft.assetRefs?.length) {
      photos.forEach(photo => { if (attempt.serverDraft.assetRefs.some(ref => ref.assetId === photo.asset?.assetId)) photo.assetRequestId = saved.requestId; });
      await globalThis.HeirloomCurrentDraft?.save();
    }
    verifySavedDraft(saved, attempt.expected);
    if (!saved.editToken) throw new Error('The saved design could not be verified. Please try saving it again.');
    attempt.draftReceipt = { requestId: saved.requestId, editToken: saved.editToken };
    serverPending = root.dataset.customerLoggedIn === 'true' ? null : attempt.draftReceipt;
    saveServerPending();
    return attempt.draftReceipt;
  };
  const prepareServerCart = async (draft, expected, flow = 'purchase') => {
    const data = await server.request('/v1/checkout/prepare', {
      method: 'POST', body: JSON.stringify({ requestId: draft.requestId }),
      headers: { 'content-type': 'application/json', 'x-draft-token': draft.editToken },
    });
    const fields = { ...(data.checkout?.fields || {}) };
    if (flow === 'optional') fields['properties[_preview_flow]'] = 'optional';
    else delete fields['properties[_preview_flow]'];
    const body = new FormData();
    Object.entries(fields).forEach(([key, value]) => body.set(key, String(value)));
    return {
      body,
      expected: {
        ...expected, server: true, requestId: draft.requestId, revisionId: data.revisionId,
        variantId: String(data.shopifyVariantId), sku: expected.sku || '',
        properties: data.lineItemProperties || {},
      },
    };
  };
  const cartHasExpected = (items, expected) => expected?.server
    ? items.some(item => item.properties?.['_3D Heirloom Request'] === expected.requestId && item.properties?.['_3D Heirloom Revision'] === expected.revisionId)
    : items.some(item => item.properties?._design_id === expected?.id);
  const confirmPreviewRequestInCart = async (expected = {}) => {
    if (!expected.id) return false;
    const visit = upload.beginAttempt();
    await verifyPendingDraft(expected, visit);
    const cart = await visit.wait(fetchCart());
    order.verify(cart.items, expected);
    return true;
  };
  const recheck = async () => {
    if (busy || !pending) return;
    const visit = upload.beginAttempt();
    lock(true);
    try {
      const cart = await visit.wait(fetchCart());
      if (!cartHasExpected(cart.items, pending) && Date.now() - (pending.sentAt || Date.now()) > 120000) {
        clearPending();
        setStatus('No saved customization was found. Check your details before trying again.');
      } else { order.verify(cart.items, pending); await verifyPendingDraft(pending, visit); complete(); }
    }
    catch { if (!visit.isActive()) return; setStatus('The previous result is still unconfirmed. Review your cart before trying again.', true); }
    finally { if (visit.isActive() && !leaving) lock(false); }
  };
  q('[data-relief-recheck]').addEventListener('click', recheck);
  const submitToCart = async ({ navigate = true, wallet = false } = {}) => {
    if (busy || loading() || pending) return;
    if (!photosReady() || !variant()?.available) { setStatus(requiredPhotoCount === 3 ? 'Choose your options and upload all 3 photos.' : requiresPhoto() ? 'Choose your options and upload a photo.' : 'Choose an available option.', true); return; }
    if (globalThis.HeirloomCurrentDraft?.context) {
      silentCart = !navigate;
      lock(true);
      try {
        const restored = await globalThis.HeirloomCurrentDraft.reusePurchase();
        if (restored) {
          restored.expected.variantId = String(variant().id);
          restored.expected.sku = variant().sku || '';
          order.verify(restored.cart.items, restored.expected);
          if (!navigate) return restored.expected;
          if (wallet) { await globalThis.HeirloomSnowmanWallet.open({ root, form, saved: restored.expected }); return restored.expected; }
          openCartDestination();
          return restored.expected;
        }
      } catch (error) { setStatus(error.message || 'Your cart could not be checked. Please try again.', true); throw error; }
      finally { if (!leaving) lock(false); }
    }
    const input = purchaseInput();
    if (savedPurchase?.key === input.key && input.files.length === savedPurchase.files.length && input.files.every((file, index) => file === savedPurchase.files[index])) {
      silentCart = !navigate;
      lock(true);
      try {
        const cart = await fetchCart();
        if (cartHasExpected(cart.items, savedPurchase.expected)) {
          order.verify(cart.items, savedPurchase.expected);
          await verifyPendingDraft(savedPurchase.expected, upload.beginAttempt());
          if (!navigate) return savedPurchase.expected;
          if (wallet) { await globalThis.HeirloomSnowmanWallet.open({ root, form, saved: savedPurchase.expected }); return savedPurchase.expected; }
          openCartDestination();
          return savedPurchase.expected;
        }
        savedPurchase = null;
      } finally { if (!leaving) lock(false); }
    }
    silentCart = wallet || !navigate || !previewRequestMode && !directCheckout;
    activeLoginGate = null;
    const visit = upload.beginAttempt();
    busyAction = wallet ? 'wallet' : 'cart';
    lock(true);
    if (activeLoginGate?.wait && savingDialog.open) savingDialog.close();
    setStatus(silentCart ? '' : activeLoginGate?.wait ? 'Sign in in the opened window. Your design is being saved in the background.' : previewRequestMode ? 'Uploading your design for the free preview request. Please keep this page open…' : 'Adding your personalized gift to your cart. Please keep this page open…');
    savingMessage.textContent = previewRequestMode ? 'Uploading your design to the cart…' : 'Saving to cart…';
    let attempt = null;
    try {
      attempt = await visit.wait(prepareCartAttempt());
      if (!checkoutAssetRefs && requiresPhoto() && checkoutAssetRefsPromise) {
        checkoutAssetRefs = await visit.wait(checkoutAssetRefsPromise).catch(() => false);
      }
      const draftReceipt = await saveCartDraft(attempt, visit);
      let cartBody = attempt.body, cartExpected = attempt.expected;
      if (checkoutAssetRefs && requiresPhoto()) {
        const prepared = await visit.wait(prepareServerCart(draftReceipt, attempt.expected, previewRequestMode ? 'optional' : 'purchase'));
        cartBody = prepared.body;
        cartExpected = prepared.expected;
      }
      pending = { ...cartExpected, draftReceipt, sentAt: Date.now() };
      try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch { /* Current page still prevents duplicate submission. */ }
      const response = await visit.wait(upload.send(addUrl.href, cartBody, {
        message: silentCart || activeLoginGate?.wait ? null : savingMessage,
        title: silentCart ? null : savingTitle,
        titleText: previewRequestMode ? 'SAVING YOUR PREVIEW REQUEST' : 'ADDING YOUR PERSONALIZED GIFT TO CART',
        savingText: previewRequestMode ? 'Saving your preview request' : 'Saving to cart',
      }));
      const receipt = await visit.wait(response.json());
      if (!response.ok) {
        const cart = await visit.wait(fetchCart());
        if (!cartHasExpected(cart.items, pending)) clearPending();
        throw new Error(receipt.description || 'This item could not be added. Please check the selected options.');
      }
      order.verify(receipt.items || [receipt], pending);
      const completed = pending;
      rememberPurchase(completed);
      await globalThis.HeirloomCurrentDraft?.remember({ requestId: completed.requestId || completed.draftReceipt?.requestId, id: completed.id });
      preparedAttempt = null;
      if (wallet) {
        clearPending();
        busy = false;
        root.inert = false;
        root.dataset.simpleSubmitting = 'false';
        savingDialog?.close?.();
        render();
        await globalThis.HeirloomSnowmanWallet.open({ root, form, saved: completed });
        return completed;
      }
      if (navigate) {
        complete();
        return completed;
      }
      clearPending();
      previewRequestMode = null;
      if (!navigate) {
        leaving = false;
        busy = false;
        root.inert = false;
        root.dataset.simpleSubmitting = 'false';
        savingDialog?.close?.();
        render();
        setStatus('Your personalized gift is saved in your cart.');
        return completed;
      }
    } catch (error) {
      if (!visit.isActive()) return;
      if (attempt && pending) {
        try {
          const cart = await visit.wait(fetchCart());
          order.verify(cart.items, pending);
          await verifyPendingDraft(pending, visit);
          const completed = pending;
          rememberPurchase(completed);
          await globalThis.HeirloomCurrentDraft?.remember({ requestId: completed.requestId || completed.draftReceipt?.requestId, id: completed.id });
          preparedAttempt = null;
            if (wallet) {
              clearPending();
              busy = false;
              root.inert = false;
              root.dataset.simpleSubmitting = 'false';
              savingDialog?.close?.();
              render();
              await globalThis.HeirloomSnowmanWallet.open({ root, form, saved: completed });
            } else if (navigate) complete();
          else {
            clearPending();
            previewRequestMode = null;
            leaving = false;
            busy = false;
            root.inert = false;
            root.dataset.simpleSubmitting = 'false';
            savingDialog?.close?.();
            render();
            setStatus('Your personalized gift is saved in your cart.');
          }
          return completed;
        } catch { /* Never re-post an ambiguous request automatically. */ }
      }
      if (!visit.isActive()) return;
      activeLoginGate?.close?.();
      activeLoginGate = null;
      setStatus(pending ? 'The result could not be confirmed. Review your cart or check the saved customization; do not submit it again.' : error.message || 'Your personalization could not be saved. Please try again.', true);
    } finally { if (visit.isActive() && !leaving) lock(false); }
  };
  form.addEventListener('submit', event => { void submitToCart({ wallet: event.submitter?.matches?.('[data-snowman-paypal]') === true }).catch(error => setStatus(error.message || 'Your cart could not be checked. Try again.', true)); });
  document.addEventListener('snowman-wallet-ready', render);
  window.addEventListener('pageshow', event => {
    leaving = false;
    activeLoginGate?.close?.();
    activeLoginGate = null;
    lock(false);
    setStatus(pending ? 'Review your cart or check the saved customization before trying again.' : readyStatus());
  });
  // Enhance Planet options while keeping the Shopify select as the source of truth.
  qa('[data-relief-picker]').forEach(picker => {
    const input = picker.parentElement.querySelector('[data-relief-option]');
    const label = picker.parentElement.querySelector('label');
    const trigger = picker.querySelector('[data-relief-picker-trigger]');
    const valueLabel = picker.querySelector('[data-relief-picker-value]');
    const list = picker.querySelector('[data-relief-picker-list]');
    const choices = [...list.querySelectorAll('[data-relief-choice]')];
    let active = input.selectedIndex, search = '', lastKeyAt = 0;
    const disabled = () => input.matches(':disabled');
    const close = () => {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-activedescendant');
    };
    const sync = () => {
      valueLabel.textContent = input.selectedOptions[0]?.textContent || '';
      choices.forEach(choice => choice.setAttribute('aria-selected', String(choice.dataset.reliefChoice === input.value)));
      active = input.selectedIndex;
    };
    const highlight = index => {
      active = Math.max(0, Math.min(choices.length - 1, index));
      choices.forEach((choice, i) => { choice.dataset.active = String(i === active); });
      trigger.setAttribute('aria-activedescendant', choices[active].id);
      choices[active].scrollIntoView({ block: 'nearest' });
    };
    const open = () => {
      if (disabled()) return;
      const rect = trigger.getBoundingClientRect();
      const below = window.innerHeight - rect.bottom - 16, above = rect.top - 16;
      const useAbove = below < 200 && above > below;
      picker.dataset.placement = useAbove ? 'above' : 'below';
      list.style.maxHeight = `${Math.min(288, Math.max(96, useAbove ? above : below))}px`;
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      highlight(input.selectedIndex);
    };
    const choose = (index, focus = true) => {
      if (disabled() || !choices[index]) return;
      input.value = choices[index].dataset.reliefChoice;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      if (focus) trigger.focus({ preventScroll: true });
    };
    trigger.addEventListener('click', () => { if (list.hidden) open(); else close(); });
    trigger.addEventListener('keydown', event => {
      if (disabled()) return;
      const isOpen = !list.hidden;
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        if (!isOpen) open();
        if (event.key === 'Home') highlight(0);
        else if (event.key === 'End') highlight(choices.length - 1);
        else if (isOpen) highlight(active + (event.key === 'ArrowDown' ? 1 : -1));
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (isOpen) choose(active); else open();
      } else if (event.key === 'Escape' && isOpen) {
        event.preventDefault(); close();
      } else if (event.key === 'Tab' && isOpen) {
        choose(active, false);
      } else if (event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        event.preventDefault();
        const now = Date.now();
        search = now - lastKeyAt > 700 ? event.key.toLowerCase() : search + event.key.toLowerCase();
        lastKeyAt = now;
        const term = [...search].every(char => char === search[0]) ? search[0] : search;
        const start = active + (term.length === 1 ? 1 : 0);
        const index = choices.map((_, offset) => (start + offset) % choices.length).find(i => choices[i].dataset.reliefChoice.toLowerCase().startsWith(term));
        if (index !== undefined) { if (isOpen) highlight(index); else choose(index, false); }
      }
    });
    list.addEventListener('mousedown', event => event.preventDefault());
    list.addEventListener('click', event => {
      const choice = event.target.closest('[data-relief-choice]');
      if (choice && choices.includes(choice)) choose(choices.indexOf(choice));
    });
    document.addEventListener('pointerdown', event => { if (!picker.contains(event.target)) close(); });
    picker.addEventListener('focusout', event => { if (!picker.contains(event.relatedTarget)) close(); });
    window.addEventListener('resize', close);
    input.addEventListener('change', sync);
    sync();
    input.hidden = true;
    label.htmlFor = trigger.id;
    picker.hidden = false;
  });
  globalThis.HeirloomReliefPersonalization = {
    isReady: () => Boolean(!busy && !pending && photosReady() && !!variant()?.available),
    exportPreviewRequest,
    restorePreviewRequest,
    setPreviewRequestMode,
    clearPreviewRequestMode,
    submitPreviewRequest: ({ email = '', navigate = true } = {}) => {
      setPreviewRequestMode(email);
      return submitToCart({ navigate });
    },
    confirmPreviewRequestInCart,
  };
  globalThis.addEventListener('pagehide', () => { archiveController?.abort(); clearTimeout(archiveTimer); archiveTimer = 0; });
  const quantityChanged = () => { prepareArchiveInBackground(); void recovery?.save(); };
  form.elements.namedItem('quantity')?.addEventListener('input', quantityChanged);
  form.elements.namedItem('quantity')?.addEventListener('change', quantityChanged);
  const recovery = globalThis.HeirloomDraftRecovery?.connect({ productHandle: product.handle, capture: captureDraft, restore: restorePreviewRequest });
  globalThis.HeirloomCurrentDraft = recovery;
  globalThis.HeirloomPreviewRequest?.bind(q('[data-free-preview-request]'), () => submitToCart({ navigate: false }));
  root.dataset.reliefAdapterReady = 'true';
  if (server?.ensureEagerUploads) void server.ensureEagerUploads().then(async enabled => {
    await recovery?.ready;
    eagerUploads = enabled === true;
    render();
    prepareArchiveInBackground();
    if (eagerUploads) photos.filter(photo => photo.file && !photo.asset && !photo.uploading).forEach(photo => { void uploadPhotoAsset(photo).catch(() => {}); });
  }).catch(() => { eagerUploads = false; prepareArchiveInBackground(); });
  if (server?.ensureCheckoutAssetRefs) {
    checkoutAssetRefsPromise = server.ensureCheckoutAssetRefs();
    void checkoutAssetRefsPromise.then(enabled => { checkoutAssetRefs = enabled === true; }).catch(() => { checkoutAssetRefs = false; });
  }
  render();
  if (!pending) setStatus(readyStatus());
  if (pending) { setStatus('Checking your previous customization…'); void recheck(); }
})();
